import React from 'react';

export default ({handleSortClick, order, sortedBy}) => {
  function createClasses(key) {
    if (sortedBy === key) return `${order ? 'asc' : 'desc'} active`;
    return '';
  }

  return (
    <div className='list-scene__table-header'>
      <div
        className={`list-scene__table-header-element ${createClasses('submissionDate')} _width_pc_8`}
        onClick={handleSortClick('submissionDate')}
      >
        <div>Submission Date</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>

      <div
        className={`list-scene__table-header-element ${createClasses('componentType')} _width_pc_20`}
        onClick={handleSortClick('componentType')}
      >
        <div>Type</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>

      <div
        className={`list-scene__table-header-element ${createClasses(
          'name'
        )} list-scene__table-row-element_place_filler`}
        onClick={handleSortClick('name')}
      >
        <div>Name</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>

      <div
        className={`list-scene__table-header-element ${createClasses('status')} _width_pc_15`}
        onClick={handleSortClick('status')}
      >
        <div>Status</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>

      <div className={`list-scene__table-header-element ${createClasses('actions')} _width_pc_12`} />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/FamilyList/TableHeader.jsx